export default "__VITE_ASSET__plI$H$dT__"